import NotificationWrapper from './NotificationWrapper';

export default NotificationWrapper;
